import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { getOrderRetailDeliveryFee } from '../../utils/selectors';

export function shouldRenderToggle(cartTotal, options) {
  const {
    memberCreditsApplied,
    hasStoreCredits,
    hasMemberCredits,
    hasPromoConflicts,
    membershipPrice,
  } = options;

  if (
    (hasMemberCredits && cartTotal >= membershipPrice) ||
    memberCreditsApplied > 0
  ) {
    return true;
  }

  if (hasPromoConflicts && hasStoreCredits) {
    return true;
  }

  return false;
}

export function shouldRenderv2Components(
  tokenToCashv2Enabled,
  creditsRemaining,
  creditsUsed,
  cartHasPromoConflicts
) {
  if (!tokenToCashv2Enabled) {
    return false;
  }

  if (creditsRemaining === 0 && creditsUsed >= 0) {
    return false;
  }

  if (cartHasPromoConflicts) {
    return false;
  }

  return true;
}

export function getCartTotalWithoutConflictingPromos(
  cart,
  retailDeliveryFee = 0
) {
  const shipping = cart?.shipping ?? 0;
  const tax = cart?.tax ?? 0;
  const tarriff = cart?.tariffSurchargeAmount ?? 0;
  const conflictsMap =
    cart?.promoConflicts?.reduce((conflictMap, promoConflict) => {
      conflictMap[promoConflict.promoId] = true;
      return conflictMap;
    }, {}) ?? {};

  return (
    cart?.cartLineDiscounts?.reduce((subtotal, cartLineDiscount) => {
      if (conflictsMap[cartLineDiscount.promoId]) {
        return subtotal;
      }
      return subtotal - cartLineDiscount.amount;
    }, cart.subtotal + shipping + tax + tarriff + retailDeliveryFee) ?? 0
  );
}

export function useGetCartTotalWithoutConflictingPromos() {
  const cart = useSelector(state => state.checkout);
  const retailDeliveryFee = useSelector(getOrderRetailDeliveryFee);

  return useMemo(
    () => getCartTotalWithoutConflictingPromos(cart, retailDeliveryFee ?? 0),
    [cart, retailDeliveryFee]
  );
}

export const CreditStatus = {
  applied: 'applied',
  applying: 'applying',
  available: 'available',
  no_credits_remaining: 'no_credits_remaining',
  removing: 'removing',
  unavailable: 'unavailable',
};
